(() => {
  const slideshows = [...document.querySelectorAll('[data-birei-slideshow]')];

  slideshows.forEach((slideshow) => {
    const slides = [...slideshow.querySelectorAll('[data-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-slide-to]')];
    if (slides.length < 2) return;

    let current = 0;
    let timer;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      slideshow.dataset.activeStyle = slides[current].dataset.style || 'full';
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    const stopAutoplay = () => window.clearInterval(timer);
    const startAutoplay = () => {
      stopAutoplay();
      if (slideshow.dataset.autoplay === 'true') {
        timer = window.setInterval(() => showSlide(current + 1), Number(slideshow.dataset.speed) || 5000);
      }
    };

    slideshow.querySelector('.birei-hero__arrow--prev')?.addEventListener('click', () => {
      showSlide(current - 1);
      startAutoplay();
    });
    slideshow.querySelector('.birei-hero__arrow--next')?.addEventListener('click', () => {
      showSlide(current + 1);
      startAutoplay();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      showSlide(Number(dot.dataset.slideTo));
      startAutoplay();
    }));
    slideshow.addEventListener('mouseenter', stopAutoplay);
    slideshow.addEventListener('mouseleave', startAutoplay);
    slideshow.addEventListener('focusin', stopAutoplay);
    slideshow.addEventListener('focusout', startAutoplay);
    startAutoplay();
  });
})();
